import React, { Component } from "react";
import Layout from "../Layout";
import PropagateLoader from "react-spinners/PropagateLoader";
import BootstrapTable from "react-bootstrap-table-next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faEdit,
  faTrash,
  faEye,
  faFilePdf,
  faQuestionCircle,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import {
  Modal,
  Button,
  ButtonGroup,
  Row,
  Col,
  OverlayTrigger,
  Popover,
  Form,
  ButtonToolbar,
} from "react-bootstrap";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ReactTooltip from "react-tooltip";
import Adjunto from "./Adjunto";
import Galeria from "./Galeria";
import ListaAdjuntos from "./ListaAdjuntos";
import ReportePDF from "./ReportePDF";

class F70s extends Component {
  constructor(props) {
    super(props);
    this.GetActionFormat = this.GetActionFormat.bind(this);
    this.state = {
      // Estado relacionado con el modelo
      id: "",
      no_de_inventario: "",
      concepto: "",
      localidad: "",
      ubicacion: "",
      tipo: "",
      uso_actual_del_bien: "",
      zona: "",
      servicios_y_equipamiento: "",
      medio_de_adquisicion: "",
      tipo_documento: "ESCRITURA",
      identificador_de_documento: "",
      clave_catastral: "",
      fecha_adquisicion: null,
      valor_del_bien: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",

      // Estados para la ventana modal
      modal: false, // ventana modal generica para modificar y Nuevo cerrada
      modalEliminar: false, //Modal Eliminar
      modalVisualizar: false, //Modal Visualizar
      modalAccion: "", // Acción del boton principal de la ventana modal para el switch
      modalTitle: "", // Titulo para la ventana modal generica
      frm_lista_documentos: [], // Lista de documentos del registro
      frm_archivo: null,
      frm_descripcion_doc: "",
      f70s: [], // Listado de elementos para la tabla
      loading: false,
      noEdit: false,
    };
  }

  componentDidMount = () => {
    this.cargaTabla();
  }
  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  noEditFnc = async () => {
    let noEdit = false
    let busca = this.props.location.pathname.split("/")
    busca.shift()
    let misAmbitos = localStorage.ambitos.split(",")

    if (busca[2]) {
      let res = null
      res = await axios({
        method: "get",
        url:
          "http://143.198.191.211/api/Ambito/" +
          busca[2] +
          "?api_token=" +
          localStorage.api_token,
        data: {},
      })

      let data = res.data
      if (data.fecha_finalizado != null) {
        noEdit = true
      } else {
        if (misAmbitos.includes(busca[2])) {
          noEdit = false
        } else {
          noEdit = true
        }
      }

      if (localStorage.permisos.includes("admin")) {
        noEdit = false
      }
    }
    if (noEdit) {
      this.setState({ noEdit: true })
    } else {
      this.setState({ noEdit: false })
    }
  }

  cargaTabla = () => {
    this.setState({ loading: true });
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/F70/ambito/" +
        this.props.match.params.ambito_id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.setState({ f70s: res.data, loading: false });
    }).finally(() => {
      this.noEditFnc();
    });
  };

  cargaDocumentos = (id) => {
    axios({
      method: "get",
      url:
        "http://143.198.191.211/api/Documento/" +
        this.props.match.params.ambito_id +
        "/70/" +
        id +
        "?api_token=" +
        localStorage.api_token,
      data: {},
    }).then((res) => {
      this.closeModalDocumentos();
      this.setState({ frm_lista_documentos: res.data, loading: false });
    });
  };

  closeModalDocumentos = () => {
    this.setState({ modalDocumentos: false });
  };

  showModalEliminar = () => {
    this.setState({ modalEliminar: true });
  };

  closeModalEliminar = () => {
    this.setState({ modalEliminar: false });
  };

  showModalVisualizar = () => {
    this.setState({ modalVisualizar: true });
  };

  closeModalVisualizar = () => {
    this.setState({ modalVisualizar: false });
  };

  showModal = () => {
    this.setState({ modal: true });
  };

  closeModal = () => {
    this.setState({ modal: false });
  };

  ModalNuevo = () => {
    this.showModal();
    this.setState({
      modalLabel: "Guardar",
      variante: "primary",
      modalAccion: "insert",
      modalTitle: "Registro nuevo",
      id: "",
      no_de_inventario: "",
      concepto: "",
      localidad: "",
      ubicacion: "",
      tipo: "",
      uso_actual_del_bien: "",
      zona: "",
      servicios_y_equipamiento: "",
      medio_de_adquisicion: "",
      tipo_documento: "ESCRITURA",
      identificador_de_documento: "",
      clave_catastral: "",
      fecha_adquisicion: null,
      valor_del_bien: 0,
      observaciones: "",
      usuario_id: "",
      ambito_id: "",
    });
  };

  ModalModificar = (row) => {
    this.showModal();
    this.setState({
      modalLabel: "Modificar",
      variante: "warning",
      modalAccion: "update",
      modalTitle: "Modificación",
      id: row.id,
      no_de_inventario: row.no_de_inventario,
      concepto: row.concepto,
      localidad: row.localidad,
      ubicacion: row.ubicacion,
      tipo: row.tipo,
      uso_actual_del_bien: row.uso_actual_del_bien,
      zona: row.zona,
      servicios_y_equipamiento: row.servicios_y_equipamiento,
      medio_de_adquisicion: row.medio_de_adquisicion,
      tipo_documento: row.tipo_documento,
      identificador_de_documento: row.identificador_de_documento,
      clave_catastral: row.clave_catastral,
      fecha_adquisicion: row.fecha_adquisicion,
      valor_del_bien: row.valor_del_bien,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalVisualizar = (row) => {
    this.cargaDocumentos(row.id);
    this.showModalVisualizar();
    this.setState({
      modalLabel: "Visualizar",
      variante: "warning",
      modalAccion: "view",
      modalTitle: "Visualizar",
      id: row.id,
      no_de_inventario: row.no_de_inventario,
      concepto: row.concepto,
      localidad: row.localidad,
      ubicacion: row.ubicacion,
      tipo: row.tipo,
      uso_actual_del_bien: row.uso_actual_del_bien,
      zona: row.zona,
      servicios_y_equipamiento: row.servicios_y_equipamiento,
      medio_de_adquisicion: row.medio_de_adquisicion,
      tipo_documento: row.tipo_documento,
      identificador_de_documento: row.identificador_de_documento,
      clave_catastral: row.clave_catastral,
      fecha_adquisicion: row.fecha_adquisicion,
      valor_del_bien: row.valor_del_bien,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ModalEliminar = (row) => {
    this.showModalEliminar();
    this.setState({
      modalAccion: "delete",
      id: row.id,
      no_de_inventario: row.no_de_inventario,
      concepto: row.concepto,
      localidad: row.localidad,
      ubicacion: row.ubicacion,
      tipo: row.tipo,
      uso_actual_del_bien: row.uso_actual_del_bien,
      zona: row.zona,
      servicios_y_equipamiento: row.servicios_y_equipamiento,
      medio_de_adquisicion: row.medio_de_adquisicion,
      tipo_documento: row.tipo_documento,
      identificador_de_documento: row.identificador_de_documento,
      clave_catastral: row.clave_catastral,
      fecha_adquisicion: row.fecha_adquisicion,
      valor_del_bien: row.valor_del_bien,
      observaciones: row.observaciones,
      usuario_id: row.usuario_id,
      ambito_id: row.ambito_id,
    });
  };

  ejecutar = (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    switch (this.state.modalAccion) {
      case "update":
        this.actualiza();
        break;
      case "insert":
        this.registra();
        break;
      case "delete":
        this.borra();
        break;
      default:
    }
  };

  registra = () => {
    let data = {
      //Recoger la información para el registro
      no_de_inventario: this.state.no_de_inventario,
      concepto: this.state.concepto,
      localidad: this.state.localidad,
      ubicacion: this.state.ubicacion,
      tipo: this.state.tipo,
      uso_actual_del_bien: this.state.uso_actual_del_bien,
      zona: this.state.zona,
      servicios_y_equipamiento: this.state.servicios_y_equipamiento,
      medio_de_adquisicion: this.state.medio_de_adquisicion,
      tipo_documento: this.state.tipo_documento,
      identificador_de_documento: this.state.identificador_de_documento,
      clave_catastral: this.state.clave_catastral,
      fecha_adquisicion: this.state.fecha_adquisicion,
      valor_del_bien: this.state.valor_del_bien,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios.post("http://143.198.191.211/api/F70", data, config).then((res) => {
      this.closeModal();
      toast.success(res.data.text, { autoClose: 1000 });
      this.cargaTabla();
      this.setState({ loading: false });
    });
  };

  actualiza = () => {
    let data = {
      //Recoger la información para el registro
      id: this.state.id,
      no_de_inventario: this.state.no_de_inventario,
      concepto: this.state.concepto,
      localidad: this.state.localidad,
      ubicacion: this.state.ubicacion,
      tipo: this.state.tipo,
      uso_actual_del_bien: this.state.uso_actual_del_bien,
      zona: this.state.zona,
      servicios_y_equipamiento: this.state.servicios_y_equipamiento,
      medio_de_adquisicion: this.state.medio_de_adquisicion,
      tipo_documento: this.state.tipo_documento,
      identificador_de_documento: this.state.identificador_de_documento,
      clave_catastral: this.state.clave_catastral,
      fecha_adquisicion: this.state.fecha_adquisicion,
      valor_del_bien: this.state.valor_del_bien,
      observaciones: this.state.observaciones,
      usuario_id: localStorage.id,
      ambito_id: this.props.match.params.ambito_id,
      api_token: localStorage.api_token,
    };
    let config = {};

    axios
      .put("http://143.198.191.211/api/F70/" + this.state.id, data, config)
      .then((res) => {
        this.closeModal();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  borra = () => {
    let data = {
      api_token: localStorage.api_token,
    };
    let config = {};
    axios
      .delete(
        "http://143.198.191.211/api/F70/" +
        this.state.id +
        "?api_token=" +
        localStorage.api_token,
        data,
        config
      )
      .then((res) => {
        this.closeModalEliminar();
        toast.success(res.data.text, { autoClose: 1000 });
        this.cargaTabla();
        this.setState({ loading: false });
      });
  };

  onChangeNoDeInventario = e => {
    this.setState({ no_de_inventario: e.target.value });
  };

  onChangeConcepto = e => {
    this.setState({ concepto: e.target.value });
  };

  onChangeLocalidad = e => {
    this.setState({ localidad: e.target.value });
  };

  onChangeUbicacion = e => {
    this.setState({ ubicacion: e.target.value });
  };

  onChangeTipo = e => {
    this.setState({ tipo: e.target.value });
  };

  onChangeUsoActualDelBien = e => {
    this.setState({ uso_actual_del_bien: e.target.value });
  };

  onChangeZona = e => {
    this.setState({ zona: e.target.value });
  };

  onChangeServiciosYEquipamiento = e => {
    this.setState({ servicios_y_equipamiento: e.target.value });
  };

  onChangeMedioDeAdquisicion = e => {
    this.setState({ medio_de_adquisicion: e.target.value });
  };

  onChangeTipoDocumento = e => {
    this.setState({ tipo_documento: e.target.value });
  };

  onChangeIdentificadorDeDocumento = e => {
    this.setState({ identificador_de_documento: e.target.value });
  };

  onChangeClaveCatastral = e => {
    this.setState({ clave_catastral: e.target.value });
  };

  onChangeFechaAdquisicion = e => {
    this.setState({ fecha_adquisicion: e.target.value });
  };

  onChangeValorDelBien = e => {
    this.setState({ valor_del_bien: e.target.value });
  };

  onChangeObservaciones = e => {
    this.setState({ observaciones: e.target.value });
  };

  onChangeUsuarioId = e => {
    this.setState({ usuario_id: e.target.value });
  };

  onChangeAmbitoId = e => {
    this.setState({ ambito_id: e.target.value });
  };



  onChangefrm_descripcion_doc = (e) => {
    this.setState({ frm_descripcion_doc: e.target.value });
  };

  GetActionFormat = (cell, row, idx, noEdit) => {
    return (
      <div>
        <ButtonGroup size="sm">
          <button
            type="button"
            className="btn btn-outline-info btn-sm"
            size="sm"
            onClick={() => this.ModalVisualizar(row)}
            data-tip="Visualizar"
          >
            <FontAwesomeIcon icon={faEye} size="lg" />
          </button>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            size="sm"
            onClick={() => this.ModalModificar(row)}
            data-tip="Modificar"
          >
            <FontAwesomeIcon icon={faEdit} size="lg" />
          </button>
          <Adjunto
            ambito_id={this.props.match.params.ambito_id}
            formato={"70"}
            id={row.id}
            disabled={noEdit}
          />
          <button
            type="button"
            className="btn btn-outline-danger btn-sm btn-elimina"
            size="sm"
            onClick={() => this.ModalEliminar(row)}
            data-tip="Eliminar"
            disabled={noEdit}
          >
            <FontAwesomeIcon icon={faTrash} size="lg" />
          </button>
        </ButtonGroup>
      </div>
    );
  };

  render() {
    const columns = [
      {
        dataField: "no_de_inventario",
        text: "No De Inventario",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "concepto",
        text: "Concepto",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "localidad",
        text: "Localidad",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "ubicacion",
        text: "Ubicacion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "tipo",
        text: "Tipo",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "uso_actual_del_bien",
        text: "Uso Actual Del Bien",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "zona",
        text: "Zona",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "servicios_y_equipamiento",
        text: "Servicios Y Equipamiento",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "medio_de_adquisicion",
        text: "Medio De Adquisicion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "tipo_documento",
        text: "Tipo Documento",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "identificador_de_documento",
        text: "Identificador De Documento",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "clave_catastral",
        text: "Clave Catastral",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "fecha_adquisicion",
        text: "Fecha Adquisicion",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "valor_del_bien",
        text: "Valor Del Bien",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },
      {
        dataField: "observaciones",
        text: "Observaciones",
        sort: true,
        headerStyle: () => { return { width: "170px" }; }
      },

      {
        dataField: "",
        text: "Acción",
        formatter: this.GetActionFormat,
        formatExtraData: this.state.noEdit,
        headerStyle: () => {
          return {
            width: "140px",
            zIndex: "99",
          };
        },
      },
    ];

    const { SearchBar } = Search;
    const popover = (
      <Popover id="popover-basic">
        <Popover.Title as="h3">Ayuda</Popover.Title>
        <Popover.Content>{this.state.input_tooltip}</Popover.Content>
      </Popover>
    );

    return (
      <Layout>
        <ToastContainer />
        <div
          id="cargando"
          className={this.state.loading ? "parentDisable" : ""}
          width="100%"
        >
          <div className="overlay-box">
            <PropagateLoader
              // css={}
              sizeUnit={"px"}
              size={25}
              color={"#000000"}
              loading={this.state.loading}
            />
          </div>
        </div>

        <div className="container mt-3">
          <div className="row">
            <div className="col">
              <h3 className="d-inline">INVENTARIO DE TERRENOS Y EDIFICIOS PROPIEDAD DEL MUNICIPIO Y CÉDULAS</h3>
              <br />
              <small className="text-muted">
                Gestione la información del anexo numero 70 referente
                a inventario de terrenos y edificios propiedad del municipio y cédulas, para el ámbito {this.props.match.params.ambito_id}
              </small>
            </div>
          </div>

          <div className="row mt-3">
            <div className="col-12 ">
              <ToolkitProvider
                keyField="id"
                data={this.state.f70s}
                columns={columns}
                bootstrap4
                search
              >
                {(props) => (
                  <div>
                    <div className="row">
                      <div className="col-6">
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <button
                              className="btn btn-primary btn-nuevo"
                              onClick={this.ModalNuevo}
                              data-tip="Nuevo"
                              disabled={this.state.noEdit}
                            >
                              <FontAwesomeIcon icon={faPlus} /> Nuevo
                            </button>
                          </ButtonGroup>
                          <ButtonGroup
                            className="mr-2"
                            aria-label="Second group"
                          >
                            <ReportePDF ambito_id={this.props.match.params.ambito_id}
                              anexo="70" />
                            <a
                              className="btn btn-primary"
                              data-tip="Descarga Excel"
                              target="_blank"
                              href={
                                "http://143.198.191.211/xlsx/?a=" +
                                this.props.match.params.ambito_id +
                                "&f=70"
                              }
                            >
                              <FontAwesomeIcon icon={faFileExcel} /> Descargar
                              Excel
                            </a>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </div>
                      <div className="col-6 text-right">
                        <SearchBar
                          placeholder="Buscar..."
                          {...props.searchProps}
                          className="self-align-end"
                        />
                      </div>
                    </div>

                    <BootstrapTable
                      {...props.baseProps}
                      pagination={paginationFactory()}
                      hover
                    />
                  </div>
                )}
              </ToolkitProvider>{" "}
            </div>
          </div>
        </div>

        <Modal //***************************Modal para nuevo y modificar
          show={this.state.modal}
          onHide={this.closeModal}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Row>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  No De Inventario:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="no_de_inventario"
                  value={this.state.no_de_inventario}
                  onChange={this.onChangeNoDeInventario}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Concepto:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="concepto"
                  value={this.state.concepto}
                  onChange={this.onChangeConcepto}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Localidad:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="localidad"
                  value={this.state.localidad}
                  onChange={this.onChangeLocalidad}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Ubicacion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="ubicacion"
                  value={this.state.ubicacion}
                  onChange={this.onChangeUbicacion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Tipo:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="tipo"
                  value={this.state.tipo}
                  onChange={this.onChangeTipo}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Uso Actual Del Bien:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="uso_actual_del_bien"
                  value={this.state.uso_actual_del_bien}
                  onChange={this.onChangeUsoActualDelBien}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Zona:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="zona"
                  value={this.state.zona}
                  onChange={this.onChangeZona}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Servicios Y Equipamiento:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="servicios_y_equipamiento"
                  value={this.state.servicios_y_equipamiento}
                  onChange={this.onChangeServiciosYEquipamiento}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Medio De Adquisicion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="medio_de_adquisicion"
                  value={this.state.medio_de_adquisicion}
                  onChange={this.onChangeMedioDeAdquisicion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Tipo Documento:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="select"
                  custom
                  type="text"
                  name="tipo_documento"
                  value={this.state.tipo_documento}
                  onChange={this.onChangeTipoDocumento}
                >
                  <option>ESCRITURA</option>
                  <option>CONTRATO DE COMPRA VENTA</option>
                  <option>CERTIFICADO PARCELARIO</option>
                  <option>CONVENIO</option>
                  <option>OTRO (ESPECIFIQUE)</option>
                </Form.Control>
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Identificador De Documento:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="identificador_de_documento"
                  value={this.state.identificador_de_documento}
                  onChange={this.onChangeIdentificadorDeDocumento}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Clave Catastral:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="clave_catastral"
                  value={this.state.clave_catastral}
                  onChange={this.onChangeClaveCatastral}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Fecha Adquisicion:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="date"
                  name="fecha_adquisicion"
                  value={this.state.fecha_adquisicion}
                  onChange={this.onChangeFechaAdquisicion}
                />
              </Col>
              <Col xs="12" md="4" lg="3">
                <Form.Label>
                  Valor Del Bien:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  name="valor_del_bien"
                  value={this.state.valor_del_bien}
                  onChange={this.onChangeValorDelBien}
                />
              </Col>
              <Col xs="12" md="12" lg="12">
                <Form.Label>
                  Observaciones:
                  <OverlayTrigger trigger="focus" placement="right" overlay={popover}>
                    <Button
                      tabindex="-1"
                      variant="light"
                      onClick={(e) => {
                        this.setState({ input_tooltip: "Este campo no tiene ayuda." });
                      }}
                    >
                      <FontAwesomeIcon icon={faQuestionCircle} />
                    </Button>
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="observaciones"
                  value={this.state.observaciones}
                  onChange={this.onChangeObservaciones}
                />
              </Col>
            </Form.Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancelar
            </Button>
            <Button variant={this.state.variante} onClick={this.ejecutar} className="btn-ejecutar" disabled={this.state.noEdit} >
              {this.state.modalLabel}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para eliminar
          show={this.state.modalEliminar}
          onHide={this.closeModalEliminar}
          size="sm"
          centered
        >
          <Modal.Header>
            <Modal.Title>Eliminar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Seguro que desea eliminar este registro{" "}
            <strong>{this.state.nom_direccion}</strong> ?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalEliminar}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.ejecutar} disabled={this.state.noEdit}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal //*******************************Modal para visializar
          show={this.state.modalVisualizar}
          onHide={this.closeModalVisualizar}
          dialogClassName="modal-90w"
          centered
        >
          <Modal.Header>
            <Modal.Title>Visualizar</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Modal.Body className="show-grid">
              <Row>
                <Col xs={12} md={8}>
                  <h5>Datos del Registro</h5>
                  <Row>
                    <Col xs={2} className="text-muted">
                      No De Inventario:
                    </Col>
                    <Col xs={10}>{this.state.no_de_inventario}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Concepto:
                    </Col>
                    <Col xs={10}>{this.state.concepto}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Localidad:
                    </Col>
                    <Col xs={10}>{this.state.localidad}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Ubicacion:
                    </Col>
                    <Col xs={10}>{this.state.ubicacion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo:
                    </Col>
                    <Col xs={10}>{this.state.tipo}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Uso Actual Del Bien:
                    </Col>
                    <Col xs={10}>{this.state.uso_actual_del_bien}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Zona:
                    </Col>
                    <Col xs={10}>{this.state.zona}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Servicios Y Equipamiento:
                    </Col>
                    <Col xs={10}>{this.state.servicios_y_equipamiento}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Medio De Adquisicion:
                    </Col>
                    <Col xs={10}>{this.state.medio_de_adquisicion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Tipo Documento:
                    </Col>
                    <Col xs={10}>{this.state.tipo_documento}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Identificador De Documento:
                    </Col>
                    <Col xs={10}>{this.state.identificador_de_documento}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Clave Catastral:
                    </Col>
                    <Col xs={10}>{this.state.clave_catastral}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Fecha Adquisicion:
                    </Col>
                    <Col xs={10}>{this.state.fecha_adquisicion}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Valor Del Bien:
                    </Col>
                    <Col xs={10}>{this.state.valor_del_bien}</Col>
                  </Row>
                  <Row>
                    <Col xs={2} className="text-muted">
                      Observaciones:
                    </Col>
                    <Col xs={10}>{this.state.observaciones}</Col>
                  </Row>

                </Col>
                <Col xs={12} md={4}>
                  <Row>
                    <Col xs={12}>
                      <h5>Archivos Adjuntos</h5>
                    </Col>
                    <Col xs={12}>
                      <ListaAdjuntos archivos={this.state.frm_lista_documentos} cargaDocumentos={this.cargaDocumentos} rowId={this.state.id} />
                    </Col>
                    <Col xs={12}>
                      <Galeria imagenes={this.state.frm_lista_documentos} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.closeModalVisualizar}>
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
        <ReactTooltip />
      </Layout >
    );
  }
}

export default F70s;
